import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'hash',//history
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（比如浏览器前进后退），则使用保存的位置
    if (savedPosition) {
      return savedPosition
    } else {
      // 否则滚动到顶部
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页',
            description: '欢迎访问我们的官方网站，了解公司业务与最新动态。'
          }
        }, {
          path: '/product',
          name: 'product',
          component: resolve => require(['@/view/Product'], resolve),
          meta: {
            title: '产品介绍',
            description: '查看我们的软件产品组合，包括智能小镇与大数据管理系统。'
          },
          // children: [
          //   {
          //     path: '/software',
          //     redirect: '/software/smartTown'
          //   },
          //   {
          //     path: '/software/smartTown',
          //     name: 'software',
          //     component: resolve => require(['@/view/Software_smartTown'], resolve),
          //     meta: {
          //       title: '软件产品丨智能小镇管理系统',
          //       description: '智能小镇管理系统，助力城镇数字化治理与服务。'
          //     }
          //   },
          //   {
          //     path: '/software/bigData',
          //     name: 'software',
          //     component: resolve => require(['@/view/Software_bigData'], resolve),
          //     meta: {
          //       title: '软件产品丨大数据管理系统',
          //       description: '企业级大数据管理系统，安全、稳定、可扩展。'
          //     }
          //   }
          // ]
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '解决方案',
            description: '提供咨询、实施、运维等一站式数字化服务。'
          }
        },
        {
          path: '/cooperation',
          name: 'cooperation',
          component: resolve => require(['@/view/Cooperation'], resolve),
          meta: {
            title: '渠道合作',
            description: '提供咨询、实施、运维等一站式数字化服务。'
          }
        },
        {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻动态',
            description: '查看公司新闻、行业资讯与活动公告。'
          }
        }, {
          path: '/article/:id',
          name: 'articleDetail',
          component: resolve => require(['@/view/ArticleDetail'], resolve),
          meta: {
            title: '文章详情',
            description: '查看文章详细内容。'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍',
            description: '深入了解我们的发展历程、团队与企业文化。'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js